import React, { forwardRef } from 'react'
import type { PickerProps } from 'antd/es/date-picker/generatePicker'
import cl from 'classnames'
import type { Moment } from 'moment'

import { Icon } from 'Shared/atoms/index'

import DatePickerWrapper from './DatePickerWrapper'

import styles from './styles.module.scss'

export const DatePickerIcon = () => <Icon className={styles.icon} type="datePicker" />

export interface DatePickerProps extends Omit<PickerProps<Moment>, 'picker'> {
	isReadOnly?: boolean
	picker?: 'date' | 'year'
}

const DatePicker = forwardRef<React.ElementRef<typeof DatePickerWrapper>, DatePickerProps>(
	(
		{ className, size = 'large', disabled, isReadOnly, picker = 'date', onBlur, ...props },
		ref
	) => {
		return (
			<DatePickerWrapper
				{...props}
				className={cl(styles.datePicker, className, {
					[styles.isReadOnly]: isReadOnly
				})}
				picker={picker}
				ref={ref}
				size={size}
				suffixIcon={isReadOnly ? undefined : <DatePickerIcon />}
				disabled={disabled || isReadOnly}
				placeholder={isReadOnly ? '' : props.placeholder}
			/>
		)
	}
)

export default DatePicker
